module.exports = __webpack_public_path__ + "img/water01_selected.c5cd9acf.png";